/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
/**
 *
 * @export
 * @interface RawImportedDataRequestDto
 */
export interface RawImportedDataRequestDto {
    /**
     *
     * @type {string}
     * @memberof RawImportedDataRequestDto
     */
    channelName?: string | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    budget?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    cpm?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    reachPercentage?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    totalAudience?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    impressions?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    targetAudience?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    frequency?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    trp?: number | null;
    /**
     *
     * @type {number}
     * @memberof RawImportedDataRequestDto
     */
    cpp?: number | null;
}

/**
 * Check if a given object implements the RawImportedDataRequestDto interface.
 */
export function instanceOfRawImportedDataRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RawImportedDataRequestDtoFromJSON(json: any): RawImportedDataRequestDto {
    return RawImportedDataRequestDtoFromJSONTyped(json, false);
}

export function RawImportedDataRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RawImportedDataRequestDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        channelName: !exists(json, 'channel_name') ? undefined : json['channel_name'],
        budget: !exists(json, 'budget') ? undefined : json['budget'],
        cpm: !exists(json, 'cpm') ? undefined : json['cpm'],
        reachPercentage: !exists(json, 'reach_percentage') ? undefined : json['reach_percentage'],
        totalAudience: !exists(json, 'total_audience') ? undefined : json['total_audience'],
        impressions: !exists(json, 'impressions') ? undefined : json['impressions'],
        targetAudience: !exists(json, 'target_audience') ? undefined : json['target_audience'],
        frequency: !exists(json, 'frequency') ? undefined : json['frequency'],
        trp: !exists(json, 'trp') ? undefined : json['trp'],
        cpp: !exists(json, 'cpp') ? undefined : json['cpp'],
    };
}

export function RawImportedDataRequestDtoToJSON(value?: RawImportedDataRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        channel_name: value.channelName,
        budget: value.budget,
        cpm: value.cpm,
        reach_percentage: value.reachPercentage,
        total_audience: value.totalAudience,
        impressions: value.impressions,
        target_audience: value.targetAudience,
        frequency: value.frequency,
        trp: value.trp,
        cpp: value.cpp,
    };
}
